<div class="{{className}}">
    <mat-button-toggle-group class="alphabet-filter" name="alphabetfilter" aria-label="Alphabet Filter">
        <mat-button-toggle *ngFor="let item of itemsList" (click)="clickEvent(item.label)">{{item.label}}</mat-button-toggle>
    </mat-button-toggle-group>
</div>